import { Theme } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-pro';

export const getApplianceProfilePageStyles = (theme: Theme) => ({
  applianceProfileContainer: {
    height: '100%',
    width: '100%',
    padding: 2,
  },
  
  dataGrid: {
    boxShadow: 2,
    borderRadius: 0,
    '& .MuiIconButton-root' : {
      color: theme.palette.text.primary,
    },
    '& .MuiSelect-icon' : {
      color: theme.palette.text.primary,
    },  
    [`& .${gridClasses.cell}`] : {
      color: theme.palette.text.secondary,
    },
    '& .MuiDataGrid-columnSeparator' : {
      color: theme.palette.divider,
    },
    [`& .${gridClasses.columnHeader}`] : {
      borderColor: theme.palette.divider,
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
      color: theme.palette.text.secondary,
    },
    // Category row styling
    [`& .${gridClasses.row}.category-row`]: {
      backgroundColor: theme.palette.action.hover + ' !important',
      '&:hover': {
        backgroundColor: theme.palette.action.hover + ' !important',
      },
    },
    // Subcategory row styling
    [`& .${gridClasses.row}.subcategory-row`]: {
      backgroundColor: theme.palette.action.hover + ' !important',
      '&:hover': {
        backgroundColor: theme.palette.action.hover + ' !important',
      },
    },
    // Appliance row styling
    [`& .${gridClasses.row}.appliance-row`]: {
      backgroundColor: theme.palette.background.paper + ' !important',
      '&:hover': {
        backgroundColor: theme.palette.action.hover + ' !important',
      },
    },
    // Edited row styling
    [`& .${gridClasses.row}.row--edited`]: {
      backgroundColor: theme.palette.warning.light + '40 !important',
      '&:hover': {
        backgroundColor: theme.palette.warning.light + '60 !important',
      },
    },
    // Disabled row styling
    [`& .${gridClasses.row}.row--disabled`]: {
      backgroundColor: theme.palette.action.disabledBackground + ' !important',
      color: theme.palette.action.disabled + ' !important',
      '&:hover': {
        backgroundColor: theme.palette.action.disabledBackground + ' !important',
      },
    },
    // Fix for pinned columns not getting row-level styling
    [`& .${gridClasses.row}.row--edited .MuiDataGrid-cell`]: {
      backgroundColor: theme.palette.warning.light + '40 !important',
    },
    [`& .${gridClasses.row}.row--disabled .MuiDataGrid-cell`]: {
      backgroundColor: theme.palette.action.disabledBackground + ' !important',
      color: theme.palette.action.disabled + ' !important',
    },
  },
  
  errorContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    color: theme.palette.text.secondary,
  },
  
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
});
